import React, { useContext } from 'react';

import { app } from 'context';
import { Layout } from 'ds';

import ProgressFooter from './ProgressFooter';
import StepMobileHeader from './StepMobileHeader';
import { StepProps } from './types';

import { ReactComponent as AiAssistantIcon } from 'ds/ai-assistant.svg';

interface Props extends StepProps {
  mobileStyle?: 'bottomInput' | 'compact';
}

const StepMobile: React.FC<Props> = ({
  children,
  step,
  nextHref,
  ctaDisabled,
  skippable,
  backHref,
  textLayoutProps = { paddingBottom: 200, align: 'center', flexGrow: 1 },
  onSubmit,
  requestState,
  stepCompletedEventValue,
  stepName,
  mobileStyle = 'bottomInput'
}) => {
  const { contentPaddingX } = useContext(app);
  const progressFooter = (
    <ProgressFooter
      onSubmit={onSubmit}
      step={step}
      nextHref={nextHref}
      ctaDisabled={ctaDisabled}
      skippable={skippable}
      backHref={backHref}
      requestState={requestState}
      stepCompletedEventValue={stepCompletedEventValue}
      stepName={stepName}
    />
  );

  const content = children[1];

  return (
    <Layout background="linear-gradient(86deg, rgba(0, 120, 255, 0.05) 0%, rgba(142, 95, 244, 0.05) 100%), #FFF">
      <Layout
        {...(mobileStyle === 'bottomInput' ? { height: 'calc(100vh - 120px)' } : {})}
        paddingX={contentPaddingX}
        direction="column"
      >
        <StepMobileHeader />
        <Layout {...textLayoutProps}>
          <Layout gap={24} align="center" flex>
            <AiAssistantIcon style={{ flexShrink: 0 }} width={40} height={40} />
            {children[0]}
          </Layout>
        </Layout>
      </Layout>
      <Layout
        color="white"
        {...(mobileStyle === 'bottomInput' ? {} : { borderTopRightRadius: 16, borderTopLeftRadius: 16 })}
      >
        {content}
      </Layout>
      {progressFooter}
    </Layout>
  );
};

export default StepMobile;
